import Banner from "@/components/Banner";
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import Loader from "@/components/Loader";
import PageLoading from "@/components/PageLoading";
import { TIMEOUT } from "@/constants/env";
import { statsEveryPage } from "@/hooks/useMatomo";
import { currentUserState, routerState } from "@/stores/common";
import { isServer } from "@/utils/common.util";
import { PageTransition } from "next-page-transitions";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import React, { useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import styles from "./styles.module.less";

const DocsBar = dynamic(() => import("@/components/DocsBar"), { ssr: false });

const CommonLayoutWithAuth: React.FC = (props) => {
  const { children } = props;
  const router = useRouter();
  const currentUser = useRecoilValue(currentUserState);

  const setRouterState = useSetRecoilState(routerState);

  if (!currentUser.id) {
    if (!isServer) {
      setRouterState({ redirect: router.asPath });
      router.push("/auth/login");
    }
    return <PageLoading />;
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      statsEveryPage(location.href, currentUser?.username);
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [router.asPath]);

  return (
    <>
      <Header />
      <Banner />
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <PageTransition
            timeout={TIMEOUT}
            classNames="page-transition"
            loadingComponent={<Loader />}
            loadingDelay={500}
            loadingTimeout={{
              enter: TIMEOUT,
              exit: 0,
            }}
            loadingClassNames="loading-indicator"
          >
            <React.Fragment key={router.route}>{children} </React.Fragment>
          </PageTransition>
          <DocsBar />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CommonLayoutWithAuth;
